import type { FC, ReactNode } from "react";

interface FilterChipProps {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  /** Optional leading element (e.g. a color dot) */
  icon?: ReactNode;
}

export const FilterChip: FC<FilterChipProps> = ({
  active,
  onClick,
  children,
  icon,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex cursor-pointer items-center gap-1.5 rounded-none border px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest transition-colors ${
      active
        ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:border-emerald-500/40 dark:bg-emerald-500/15 dark:text-emerald-300"
        : "border-slate-300 bg-white text-slate-600 hover:border-slate-400 hover:bg-slate-100 dark:border-slate-700 dark:bg-arti-panel dark:text-slate-400 dark:hover:border-slate-600 dark:hover:bg-arti-background"
    }`}
  >
    {icon}
    {children}
  </button>
);
